// extracted by mini-css-extract-plugin
export default {"square":"Square_square__1L3wd","squarecontent":"Square_squarecontent__kxAtd"};